import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {
	useDeleteCustomFieldDefinitionMutation,
	DeleteTicketingCustomFieldDefinitionInput,
} from './__generated__/useDeleteCustomFieldDefinitionMutation.graphql';

const mutation = graphql`
	mutation useDeleteCustomFieldDefinitionMutation($input: DeleteTicketingCustomFieldDefinitionInput!) {
		deleteTicketingCustomFieldDefinition(input: $input) {
			clientMutationId
			deletedId
		}
	}
`;

function commit(
	environment: Environment,
	input: DeleteTicketingCustomFieldDefinitionInput,
	onCompleted?: (r: useDeleteCustomFieldDefinitionMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useDeleteCustomFieldDefinitionMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useDeleteCustomFieldDefinitionMutation'};
